import SPC from "components/Stacker/constants/SearchPageConstants"
import getValue from "object-getvalue"
import SearchConfig from "global-config/search"
import shadowDOM from "components/Stacker/utils/shadowDOM"
import { getDataLayer } from "components/Stacker/utils/DataLayer"
import { getDY_SR } from "stackerConfig"

//	import SPConfig from 'config/SearchPageConfig';

// Standard Object
// queryParams: {
// 	searchTerm: 'ring',
// 	query: 'ring:relevance:price:$0-$750',
// 	sort: 'featured',
// 	pageNumber: 0,
// 	pageSize: 40,
// 	search: true,
// 	basePath: '/search'
// }

const getFormedQueryString = (selectedFilterItems) => {
  const filtersArrayKeys = Object.keys(selectedFilterItems)

  if (filtersArrayKeys.length) {
    const formattedArray = filtersArrayKeys.map((key) => {
      // if (key === SPConfig.FILTER_PRICE_CODE) {
      const query = `${key}:${selectedFilterItems[key].join(" OR ")}`

      return query
      //	}

      // const query = `${key}:"${selectedFilterItems[key].join('" OR "')}"`;

      // return query;
    })

    return formattedArray
  }
  return []
}

const heroPLP = shadowDOM.getElementById("heroPLP")

function getActiveHolidayTab(holidayTabList) {
  const itemIndex = holidayTabList.findIndex(
    (holidayItem) => holidayItem.selected
  )
  return itemIndex === -1 ? 0 : itemIndex
}

const initialState = {
  meta: {
    isDataLoading: false,
    isError: false,
    message: "",
    isMoreResultAvailable: true,
    isNoResultView: false,
    activeHolidayTabIndex: getActiveHolidayTab(
      getValue(
        { DY_SR: getDY_SR() },
        "DY_SR.data.holidayNav.holidaygiftguide",
        []
      )
    ),
  },
  pageInfo: getValue({ dataLayer: getDataLayer() }, "dataLayer.page", {}),
  data: {
    products: [],
    sorts: [],
    facets: [],
    pagination: {},
    currentQuery: "",
    freeTextSearch: "",
    searchPromoPath: "",
    searchPromoHTML: "",
    inlinePromos: [],
  },
  // This should hold both - Product List and InLine Promos
  itemsToRender: [],
  queryParams: {
    // searchTerm is the Searched keyword
    q: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.config.searchPage.searchTerm",
      ""
    ),
    // q is just searchTerm
    sort: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.config.searchPage.sort",
      SearchConfig.DEFAULT_SORT
    ),
    pageNumber: 0,
    pageSize: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.config.searchPage.pageSize",
      SearchConfig.DEFAULT_PAGE_SIZE
    ),

    basePath: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.config.searchPage.basePath"
    ),
  },
  filters: {
    selectedFilterItems: {}, // Will get updated based on user activity.
    filterString: [], // Will get updated based on user activity.
    selectedFilterItemsFromServer: {}, // Will update only on Server Response.
  },
  lastApplied: new Date().toLocaleString(),

  isFilterViewExpanded: false,
  selectedFilterCategory: "",
  isSortViewExpanded: false,
  collapsedFilterCategories: {},
  heroPromoHTML: heroPLP ? heroPLP.innerHTML : "",
  holidayNavTabs: getValue(
    { DY_SR: getDY_SR() },
    "DY_SR.data.holidayNav.holidaygiftguide"
  ),
}

export default function SearchPageReducer(
  previousState = initialState,
  action
) {
  let newState = {}
  let newProductList = []
  let newInlinePromos = []
  let newSelectedFilterObj = {}
  let newItemsToRender = []

  switch (action.type) {
    case "searchActions/SYNCHRONIZE_SEARCH_FILTERS":
      return {
        ...previousState,
        filters: {
          selectedFilterItems: action.payload.selectedFilterItems,
          selectedFilterItemsFromServer:
            action.payload.selectedFilterItemsFromServer,
          filterString: action.payload.filterString,
          lastApplied: action.payload.lastApplied,
        },
      }
    case SPC.SEARCH_START: {
      newState = {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: true,
          isMoreResultAvailable: true,
        },
      }

      const isInfiniteScroll = getValue(
        action.payload,
        "options.isInfiniteScroll",
        false
      )

      if (!isInfiniteScroll) {
        // If not Infinite Scroll then Clear All items and show Loader at the top
        newState.data = {
          ...initialState.data,
          sorts: previousState.data.sorts,
        }
        newState.itemsToRender = []
      }
      return newState
    }

    case SPC.SEARCH_NO_RESULT_FOUND:
      return {
        ...initialState,
        // Put last applied to previous state else will reset to Initial
        // which will cause change in URL and API call
        lastApplied: previousState.lastApplied,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isMoreResultAvailable: false,
          isNoResultView: true,
        },
        data: {
          ...previousState.data,
          searchPromoPath: action.payload,
        },
      }

    case SPC.SEARCH_SUCCEED: {
      const { pagination, products } = action.payload.res
      const newSelectedFilterItemsFromServer = {}
      const newCollapsedFilterCategories = {}
      if (getValue(action.payload, "options.isInfiniteScroll")) {
        // In case of Infinite scroll, preserve the Previous State and append new
        newProductList = [...previousState.data.products, ...products]
        newInlinePromos = [
          ...previousState.data.inlinePromos,
          ...action.payload.res.inlinePromos,
        ]
      } else {
        newProductList = [...products]
        newInlinePromos = [...action.payload.res.inlinePromos]
      }

      newItemsToRender = [...newProductList] // Creating new Array to have deep copy
      let lastPromo = null

      newInlinePromos.forEach((promoObj) => {
        promoObj.data = promoObj.data || "" // No Data will be available in First API Call. Just create empty placeholder
        promoObj.isInlinePromo = true
        const { displayAfter, displayLast = false } = promoObj
        if (newItemsToRender.length >= displayAfter && !displayLast) {
          newItemsToRender.splice(displayAfter, 0, promoObj)
        }
        if (displayLast) {
          lastPromo = promoObj
        }
      })

      if (lastPromo && Object.keys(lastPromo).length) {
        newItemsToRender.push(lastPromo)
      }
      // Only deriving the filters if facets are given from backend (not in case of holiday gift guide)
      if (action.payload.res.facets) {
        // Derive the Selected Filters after getting every response
        action.payload.res.facets.forEach((mainCategory) => {
          mainCategory?.values.forEach((filterItem) => {
            const { code, rangeFilter, category, decimalFilter } = mainCategory
            //if (filterItem.selected === "true") {
            // new: selected is a boolean
            if (filterItem.selected) {
              // if (filterItem.code === 'womenswomens-braceletsbangle-bracelets') {
              const {
                name: filterSubCategoryName,
                code: filterSubCategoryCode,
              } = filterItem
              const filterArray = newSelectedFilterObj[code]
              let itemToPush = filterSubCategoryCode

              let selectedQuery = `${code}:"${itemToPush}"`

              // redux form is having some issue with the decimal as part of string thus replacing it with '-'
              // but when the query goes to the server , it will be with the '.'
              if (decimalFilter && filterSubCategoryCode.indexOf(".") > -1) {
                selectedQuery = `${code}:"${itemToPush.replace(/\./g, "-")}"`
              }

              if (rangeFilter) {
                selectedQuery = `${code}:"${filterSubCategoryName}"`
                itemToPush = `[${itemToPush}]`
              } else {
                itemToPush = `"${itemToPush}"`
              }

              if (filterArray && filterArray.length) {
                // add the item here

                filterArray.push(itemToPush)
              } else {
                // create new array and add the selected filter here
                newSelectedFilterObj = {
                  ...newSelectedFilterObj,
                  [code]: [itemToPush],
                }
              }
              newSelectedFilterItemsFromServer[selectedQuery] = true
            }
            //if (category === "true") {
            // new: category is a bollean
            if (category) {
              newCollapsedFilterCategories[code] = true
            }
          })
        })
      }

      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: true,
          isNoResultView: false,
          isMoreResultAvailable:
            products.length > 0 &&
            pagination.currentPage < pagination.totalPages - 1, // currentPage starts with 0
        },
        data: {
          ...previousState.data,
          products: newProductList,
          sorts: action.payload.res.sorts,
          facets: action.payload.res.facets,
          pagination: action.payload.res.pagination,
          prevPagination: previousState.data.pagination,
          currentQuery: action.payload.res.currentQuery,
          freeTextSearch: action.payload.res.freeTextSearch,
          selectedFilterCategory: initialState.selectedFilterCategory,
          searchPromoPath: action.payload.res.searchPromoPath,
          inlinePromos: newInlinePromos,
        },
        itemsToRender: newItemsToRender,
        filters: {
          selectedFilterItems: newSelectedFilterObj,
          selectedFilterItemsFromServer: newSelectedFilterItemsFromServer,
          filterString: getFormedQueryString(newSelectedFilterObj),
        },
        queryParams: action.payload.queryParams,

        // Collapse all filters categories, Filter & Sort View
        isFilterViewExpanded: initialState.isFilterViewExpanded,
        selectedFilterCategory: initialState.selectedFilterCategory,
        isSortViewExpanded: initialState.isSortViewExpanded,
        collapsedFilterCategories: newCollapsedFilterCategories,
      }
    }
    case SPC.SEARCH_INLINE_PROMO_SUCCEED: {
      newItemsToRender = [...previousState.itemsToRender]

      // Just UPDATE the Promo Object at respective Index with Data
      action.payload.forEach((promoObj) => {
        const { displayAfter, displayLast = false } = promoObj
        if (newItemsToRender.length >= displayAfter && !displayLast) {
          newItemsToRender[displayAfter] = promoObj
        }
      })

      return {
        ...previousState,
        itemsToRender: newItemsToRender,
      }
    }

    case SPC.PRODUCT_DETAIL_FAILED:
      return {
        ...previousState,
        meta: {
          isDataLoading: false,
          isError: true,
          isMoreResultAvailable: false,
        },
      }

    // To Toggle the complete Filter View in Mobile view on Filter Hamburger icon
    case SPC.SEARCH_FILTER_VIEW_TOOGLED:
      return {
        ...previousState,
        isFilterViewExpanded: action.payload
          ? action.payload
          : !previousState.isFilterViewExpanded,
      }

    // Filter Category - To toggle the Filter Category in Desktop/Mobile view
    case SPC.SEARCH_FILTER_CATEGORY_TOOGLED:
      return {
        ...previousState,
        selectedFilterCategory:
          // If Filter Category is already expended, toogle it [empty], else Set to new Payload
          previousState.selectedFilterCategory === action.payload
            ? initialState.selectedFilterCategory
            : action.payload,
      }

    case SPC.SEARCH_FILTER_CATEGORY_SHOW:
      return {
        ...previousState,
        selectedFilterCategory: action.payload,
      }

    case SPC.SEARCH_FILTER_CATEGORY_HIDE:
      return {
        ...previousState,
        selectedFilterCategory: initialState.selectedFilterCategory,
      }

    case SPC.SEARCH_FILTER_ITEM_TOOGLED: {
      newState = {
        ...previousState,
        filters: {
          ...previousState.filters,
          selectedFilterItems: { ...previousState.filters.selectedFilterItems },
          filterString: previousState.filters.selectedFilterItems,
        },
      }

      const filters = action.payload.split(":")
      const filterCategory = filters[0]
      const filterSubCategory = filters[1]

      // if (filterCategory === SPConfig.FILTER_PRICE_CODE) {
      // 	filterSubCategory = `[${filterSubCategory}]`;
      // }
      const mainFilterCategoryArray =
        newState.filters.selectedFilterItems[filterCategory]

      if (mainFilterCategoryArray && mainFilterCategoryArray.length) {
        // remove the item from here
        const index = mainFilterCategoryArray.indexOf(filterSubCategory)
        if (index > -1) {
          mainFilterCategoryArray.splice(index, 1)
          if (!mainFilterCategoryArray.length) {
            delete newState.filters.selectedFilterItems[filterCategory]
          }
        } else {
          mainFilterCategoryArray.push(filterSubCategory)
        }
      } else {
        // add the selected filter here
        newState.filters.selectedFilterItems = {
          ...newState.filters.selectedFilterItems,
          [filterCategory]: [filterSubCategory],
        }
      }

      newState.filters.filterString = getFormedQueryString(
        newState.filters.selectedFilterItems
      )
      return newState
    }
    case SPC.SEARCH_FILTER_APPLY_CLICKED:
      return {
        ...previousState,
        isFilterViewExpanded: false,
        selectedFilterCategory: initialState.selectedFilterCategory,
        isSortViewExpanded: false,
        lastApplied: new Date().toLocaleString(),
        pagination: initialState.pagination,
      }

    // Sort
    case SPC.SORT_VIEW_TOOGLED:
      return {
        ...previousState,
        isSortViewExpanded: !previousState.isSortViewExpanded,
      }

    case SPC.SORT_VIEW_SHOW:
      return {
        ...previousState,
        isSortViewExpanded: true,
      }

    case SPC.SORT_VIEW_HIDE:
      return {
        ...previousState,
        isSortViewExpanded: false,
      }

    case SPC.SEARCH_SORT_SET_SELECTION: {
      if (previousState.queryParams.sort === action.payload) {
        return previousState
      }

      newState = {
        ...previousState,
        queryParams: {
          ...previousState.queryParams,
          sort: action.payload,
          pageNumber: 0,
        },
        filters: {
          ...previousState.filters,
          filterString: getFormedQueryString(
            previousState.filters.selectedFilterItems
          ),
        },
        lastApplied: new Date().toLocaleString(),
      }

      return newState
    }

    case SPC.SEARCH_FILTER_CLEAR_ALL:
      newState = {
        ...previousState,
        queryParams: {
          ...previousState.queryParams,
          sort: initialState.queryParams.sort,
          pageNumber: 0,
        },
        filters: {
          ...previousState.filters,
          selectedFilterItems: {},
          filterString: [],
        },
        isFilterViewExpanded: false,
        selectedFilterCategory: initialState.selectedFilterCategory,
        isSortViewExpanded: false,
        lastApplied: new Date().toLocaleString(),
      }

      return newState

    case SPC.SEARCH_FILTER_CLEAR_SELECTED: {
      newSelectedFilterObj = {}
      const previousSelectedFIlterItems =
        previousState.filters.selectedFilterItems
      const filterCategoryKey = action.payload.toLowerCase()

      const isFilteredSelected = previousSelectedFIlterItems[filterCategoryKey]

      if (isFilteredSelected && isFilteredSelected.length) {
        delete previousSelectedFIlterItems[filterCategoryKey]
      }
      newSelectedFilterObj = {
        ...previousSelectedFIlterItems,
      }

      newState = {
        ...previousState,
        queryParams: {
          ...previousState.queryParams,
          pageNumber: 0,
        },
        filters: {
          ...previousState.filters,
          selectedFilterItems: newSelectedFilterObj,
          filterString: getFormedQueryString(newSelectedFilterObj),
        },
        isFilterViewExpanded: false,
        selectedFilterCategory: initialState.selectedFilterCategory,
        isSortViewExpanded: false,
        lastApplied: new Date().toLocaleString(),
      }

      return newState
    }

    case SPC.SEARCH_PROMO_SUCCEED:
      return {
        ...previousState,
        data: {
          ...previousState.data,
          searchPromoHTML: action.payload.res,
        },
      }
    case SPC.SEARCH_PROMO_FAILED:
      return {
        ...previousState,
        data: {
          ...previousState.data,
          searchPromoHTML: "",
        },
      }

    case SPC.SEARCH_SEE_ALL_FILTERS:
      return {
        ...previousState,
        collapsedFilterCategories: {
          ...previousState.collapsedFilterCategories,
          [action.payload]: false,
        },
      }
    case SPC.SET_HOLIDAY_TAB:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          activeHolidayTabIndex: action.payload,
        },
      }
    default:
      return previousState
  }
}
